import React, { Component, PropTypes } from 'react';
import { Row, Col } from 'react-bootstrap';
import Spinner from 'react-spinner';
import 'react-spinner/react-spinner.css';
import './subscribe.scss'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getOptIns, setOptIns, subscribe } from 'actions/unsubscribeActions'

const listNames = {
  gettingStarted: "Help to get started from a real human (1-4 messages per month)",
  directPromotion: "Information about free programs in my area (2-4 messages per year)",
  marketing: "Newsletter with exclusive content and product news (4-6 messages per year)"
}

class Subscribe extends Component {

  static contextTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      optIns: null
    }
  }

  componentWillMount () {
    const {userId, listId} = this.context.location.query;
    if (!userId) {
      this.setState({error: "Oups! It seems like this link is incomplete. Please try again by clicking the link in the email."});
      return;
    }
    if (listId) {
      this.props.subscribe(userId, listId);
    } else {
      this.props.getOptIns(userId);
    }
  }

  componentDidUpdate (prevProps) {
    const {userId, listId} = this.context.location.query;
    const {subscribed, optIns} = this.props;
    if (prevProps.subscribed !== subscribed && subscribed) {
      this.context.history.replaceState(null, `/subscribed?userId=${userId}&listId=${listId}`);
    }
    if (prevProps.optIns !== optIns) {
      this.setState({optIns});
    }
  }

  optInChange(evt, optIn) {
    this.setState(prevState => ({
      optIns: {...prevState.optIns, [optIn]: evt.target.checked}
    }));
  }

  submit() {
    const {userId} = this.context.location.query;
    this.props.setOptIns(userId, this.state.optIns);
  }

  render () {
    const {listId} = this.context.location.query;
    const {error: stateError, optIns} = this.state;
    const {error: propsError, subscribing, fetchingOptIns, settingDone} = this.props;
    const error = stateError || propsError;
    const working = !error && (subscribing || fetchingOptIns);
    return <Row className="subscribe">
      <Col xs={12}>
        {error && <div className="error">There was a problem subscribing you in the list. Please try again later.<br/>Details: {error}</div>}
        {working && <div className="waiting">
          <div className="spinnerWrapper"><Spinner className="blackSpinner" /></div>
          {subscribing ? `Subscribing your from ${listNames[listId]}` : 'Fetching your lists'}
        </div>}
        {optIns && <div className="optIns">
          {Object.keys(optIns).map(optIn => <div key={optIn}>
            <input type="checkbox" readOnly={settingDone} checked={optIns[optIn]} onChange={evt => this.optInChange(evt, optIn)}/>&nbsp;{listNames[optIn]}
          </div>)}
          <div className="btn-container">
            {settingDone
              ? <span className="saved">Preferences saved {'\u2705'}</span>
              : <a onClick={::this.submit} className="btn btn-lg btn-success">Submit</a>
            }
          </div>
        </div>}
      </Col>
    </Row>;
  }
}

export default connect(
  state => ({...state.unsubscribe}),
  dispatch => bindActionCreators({
    getOptIns,
    setOptIns,
    subscribe
  }, dispatch)
)(Subscribe);



// WEBPACK FOOTER //
// ./src/views/subscribe.jsx